import request from '@/utils/request'


// 查询驻厂客服列表
export function listCompanyService(query) {
  return request({
    url: '/user/company-service/list',
    method: 'get',
    params: query
  })
}

// 查询驻厂客服分页
export function pageCompanyService(query) {
  return request({
    url: '/user/company-service/page',
    method: 'get',
    params: query
  })
}

// 查询驻厂客服详细
export function getCompanyService(data) {
  return request({
    url: '/user/company-service/detail',
    method: 'get',
    params: data
  })
}

// 新增驻厂客服
export function addCompanyService(data) {
  return request({
    url: '/user/company-service/add',
    method: 'post',
    data: data
  })
}

// 修改驻厂客服
export function updateCompanyService(data) {
  return request({
    url: '/user/company-service/edit',
    method: 'post',
    data: data
  })
}

// 删除驻厂客服
export function delCompanyService(data) {
  return request({
    url: '/user/company-service/delete',
    method: 'post',
    data: data
  })
}
